import * as React from 'react';
export const IcPercentageValue = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zM8.37 6.37A1.22 1.22 0 019.25 6a1.25 1.25 0 011.15.77c.096.227.124.477.08.72a1.3 1.3 0 01-1 1A1.25 1.25 0 018 7.25a1.22 1.22 0 01.37-.88zm-.08 5.92l6-6a1.003 1.003 0 111.42 1.42l-6 6a1 1 0 01-1.639-.325 1 1 0 01.219-1.095zm7.71.46A1.26 1.26 0 0114.75 14a1.25 1.25 0 01-1.15-.77 1.27 1.27 0 01-.08-.72 1.3 1.3 0 011-1A1.25 1.25 0 0116 12.75zM16 19H8a1 1 0 010-2h8a1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
